import { render, staticRenderFns } from "./UrgentenView.vue?vue&type=template&id=6e93b33e&scoped=true&"
import script from "./UrgentenView.vue?vue&type=script&lang=js&"
export * from "./UrgentenView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e93b33e",
  null
  
)

export default component.exports